import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 70px;
  @media screen and (max-width: 480px) {
    padding: 0 5px;
    height: 40px;
  }
`;
export const Title = styled.div`
  font-size: 30px;
  @media screen and (max-width: 480px) {
    font-size: 20px;
  }
`;
export const Menu = styled.ul`
  display: flex;
`;
export const Item = styled.li`
  list-style: none;
  margin-left: 30px;
  @media screen and (max-width: 480px) {
    font-size: 12px;
  }
`;
export const Move = styled.a``;
export const Move1 = styled.div``;
